import styled from 'styled-components';

import Title from './Title';

const OverlineTitle = styled(Title)`
  filter: var(--theme-overline-filter);
`;

export default OverlineTitle;
